/* angular:styles/component:scss;38636215c0c14d9f5700118b9780590e1276a49ead8f4e3ea6adedee8e45a3c7;D:\Techriff-Project\3amautocare\Autocare.Api\ClientApp\src\app\Formly\custom-types\button-type.component.ts */
::ng-deep .p-button {
  background:
    linear-gradient(
      135deg,
      #FFD700,
      #FFA500);
  border: none;
  color: #0F172A;
  padding: 10px 16px;
  font-size: 14px;
  transition:
    background-color 0.2s,
    color 0.2s,
    border-color 0.2s,
    box-shadow 0.2s;
  border-radius: 6px;
  outline-color: transparent;
  height: 44px;
}
/*# sourceMappingURL=button-type.component-POSVRVJQ.css.map */
